import TableStructure from 'common/TableStructure';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';


import React from 'react';

export const GridContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    
    @media (min-width: 768px) {
        overflow-x: visible;
    }
`;

const columns = () => [
    {
        field: 'id',
        headerName: <FormattedMessage id="be.seen.invoice.table.date" defaultMessage="ID" />,
        flex: 0.3,
        minWidth: 60,
    },
    {
        field: 'provider',
        headerName: <FormattedMessage id="be.seen.invoice.table.nick.name" defaultMessage="Provider" />,
        flex: 1,
        minWidth: 120,
    },
    {
        field: 'from',
        headerName: <FormattedMessage id="be.seen.invoice.table.phone.number" defaultMessage="From" />,
        flex: 1.2,
        minWidth: 150,
    },
    {
        field: 'to',
        headerName: <FormattedMessage id="be.seen.invoice.table.address" defaultMessage="To" />,
        flex: 1.2,
        minWidth: 150,
    },
    {
        field: '',
        headerName: '',
        sortable: false,
        flex: 0.3,
        minWidth: 50,
        renderCell: (params) => {
            return (
                                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                            cursor: 'pointer',
                            marginLeft: 'auto',
                            marginRight: '12px',
                        }}
                    >
                        <path
                            d="M9 18L15 12L9 6"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
            );
        },
    },
];

export default function OutOfOfficeTable({ rows, togglePopup }) {
    return (
        <>
            <GridContainer>
                <TableStructure rows={rows} columns={columns()} handleRowClick={togglePopup} />
            </GridContainer>
        </>
    );
}
